(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["filter_compare"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const filterCompare = document.querySelector('.filter-compare');
    const filterCompareButtons = document.querySelectorAll('.filter-compare__button');

    if (filterCompare && filterCompareButtons) {
      filterCompareButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const direction = button.getAttribute('data-direction');

          if (direction === 'left') {
            filterCompare.scrollLeft = 0;
          } else {
            filterCompare.scrollLeft = filterCompare.scrollWidth;
          }
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
